module.exports = __webpack_public_path__ + "static/media/Genera-SemiBold.ccf4d2df.ttf";